import { Avatar, Progress, Tabs, Tag, Image, Button } from "antd";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import TongueCheck from "./check";
import Survey from '../images/survey.png';
import DefaultUser from '../images/ic_default_header.png';
import './detail.css';

export default function TongueDetail() {
    const [activeTab, setActiveTab] = useState<"report" | "plan">("report");
    const [isCheckVisible, setIsCheckVisible] = useState<boolean>(false);
    const location = useLocation();
    const record = location.state?.analysisResult;

    return (
        <div
            className="tongue-detail"
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                backgroundColor: "white",
                flexDirection: 'column',
                marginBottom: 10
            }}>
            <div style={{
                height: '20%',
                padding: '16px',
                borderBottom: '1px solid #ddd',
                backgroundColor: "#58BEBF",
            }}>
                <div style={{ float: 'left', display: 'flex', alignItems: 'center', color: 'white' }}>
                    <Avatar size={50} src={DefaultUser} />
                    <div>
                        <span style={{ marginLeft: 10, fontSize: 14, float: 'left' }}>{record?.nickname || '用户'}</span>
                        <br />
                        <span style={{ marginLeft: 10, fontSize: 12 }}>{record?.time || '2025-02-24 14:59'}</span>
                    </div>
                </div>

                <Progress
                    size={60}
                    type="circle"
                    percent={record?.score}
                    strokeColor={'white'}
                    style={{ float: 'right' }}
                    format={(percent) => (
                        <div style={{ color: 'white' }}>
                            <div>{percent}</div>
                            <div style={{ fontSize: 8 }}>综合得分</div>
                        </div>
                    )} />
            </div>

            <Tabs
                className="tabs"
                activeKey={activeTab}
                indicator={{ size: (origin) => origin - 150, align: 'center' }}
                onChange={(key: string) => setActiveTab(key as "report" | "plan")}
            >
                <Tabs.TabPane
                    tab={<span style={{ fontSize: 14 }}>诊断报告</span>}
                    key="report"
                    style={{ textAlign: 'left', padding: '0 16px' }}
                >
                    <div className="card">
                        <p className="title">
                            <span className="icon" />
                            诊断结果
                            <Tag color={
                                record?.level === '优秀' ? '#87d068' :
                                    record?.level === '良好' ? '#2db7f5' : '#f50'
                            } style={{ marginLeft: 10 }}>{record?.level || '未知'}</Tag>
                        </p>
                        <div>
                            <strong>{record?.result}</strong>
                        </div>
                        <span>{record?.explanation}</span>
                    </div>

                    <div className="card">
                        <p className="title">
                            <span className="icon" />舌色</p>
                        <div>
                            <span className="subTitle">{record?.tongueColor.type}：</span>
                            <span>{record?.tongueColor.explain}</span>
                        </div>
                    </div>

                    <div className="card">
                        <p className="title">
                            <span className="icon" />舌形</p>
                        {record?.tongueShape.map((item: any, index: number) => {
                            return (
                                <div key={index}>
                                    <span className="subTitle">{item.type}：</span>
                                    <span>{item.explain}</span>
                                </div>
                            );
                        })}
                    </div>

                    <div className="card">
                        <p className="title">
                            <span className="icon" />苔色</p>
                        <div>
                            <span className="subTitle">{record?.tongueFurColour.type}：</span>
                            <span>{record?.tongueFurColour.explain}</span>
                        </div>
                    </div>

                    <div className="card">
                        <p className="title">
                            <span className="icon" />苔质</p>
                        {record?.tongueFurQuality.map((item: any, index: number) => {
                            return (
                                <div key={index}>
                                    <span className="subTitle">{item.type}：</span>
                                    <span>{item.explain}</span>
                                </div>
                            );
                        })}
                    </div>

                    <div className="card">
                        <p className="title">
                            <span className="icon" />概况</p>
                        <Image src={Survey} alt="概况" preview={false} loading='lazy' />
                        <Button
                            type="primary"
                            style={{
                                position: 'absolute',
                                right: 40,
                                bottom: 16,
                                borderRadius: 20,
                                backgroundColor: '#58BEBF'
                            }}
                            onClick={() => setIsCheckVisible(true)}
                        >
                            查看图像
                        </Button>
                        {isCheckVisible && <TongueCheck
                            record={record}
                            visible={isCheckVisible}
                            onCancel={() => setIsCheckVisible(false)}
                        />}
                    </div>
                </Tabs.TabPane>

                <Tabs.TabPane
                    tab="调理方案"
                    key="plan"
                    style={{ textAlign: 'left', padding: '0 16px' }}
                >
                    <div className="card">
                        <p className="title">
                            <span className="icon" />
                            病症介绍
                        </p>
                        {record?.symptomsIntroduction}
                    </div>
                    <div className="card">
                        <p className="title">
                            <span className="icon" />
                            调理建议
                        </p>
                        <p className="subTitle">食疗调理建议</p>
                        <span>{record?.food}</span>
                        <p className="subTitle">食疗宜食</p>
                        <span>{record?.foodBetter}</span>
                        <p className="subTitle">食疗忌食</p>
                        <span>{record?.foodWorse}</span>
                        <p className="subTitle">中医调理建议</p>
                        <span>{record?.medicine}</span>
                        <p className="subTitle">备注</p>
                        <span>{record?.remarks}</span>
                    </div>
                </Tabs.TabPane>
            </Tabs>
        </div>
    );
}